import { Map } from 'immutable'
import React from 'react'
import { Action, AsyncState, IOWidget, mk_widget, Pair } from 'widgets-for-react'
import { ImageSize } from '../../../../cms/blocks/types.gen'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { ImageContainer } from '../../../../cms/blocks/widgets/ImageContainer.gen'
import { TemplateState } from '../../../../cms/page/types.gen'
import { video, VideoProps } from '../../../../video'
import { CustomBlock } from '../../../../wordpress/types_and_parser/custom_blocks.gen'
import { Block } from '../../../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { CustomBlockData } from '../types.mod'

export type BSLMediaBlockProps<extra_images> = {
  kind_media: 'image' | 'video'
  image?: number
  image_alt?: string
  size?: ImageSize<extra_images>
  get_default_data_src: () => ImageSize<extra_images>
  get_default_data_srcset: () => Array<Pair<ImageSize<extra_images>, string>>
  video?: VideoProps
  caption?: string
  useCookieBar: boolean
}

export type BSLMediaBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  figure_classname: string
  media_classname: string
  image_classname: string
  placeholder_classname: string
  video_wrap_classname: string
  video_classname: string
  figcaption_classname: string
  caption_classname: string
  cookies_classname: string
  cookies_inner_classname: string
  cookies_text_classname: string
  cookies_clickable_classname: string
}>

export function BSLMediaBlock<customBlockData, extra_images>(
  props: BSLMediaBlockProps<extra_images>,
  options?: { style?: BSLMediaBlockStyle; key?: string }
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>>
> {
  return (cmsState: TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: _ => {
        const imageState = cmsState.images.get(props.image)
        return (
          <section
            className={getClassName(options, 'block_classname', 'container')}
            key={options && options.key ? options.key : 'media-block'}
          >
            <div className={getClassName(options, 'inner_classname', 'py-5')}>
              <figure className={getClassName(options, 'figure_classname', '')}>
                {props.kind_media === 'image' && props.image != null ? (
                  cmsState.images.has(props.image) ? (
                    <div className={getClassName(options, 'media_classname', '')}>
                      {ImageContainer(
                        cmsState.images.get(props.image) as AsyncState<Map<ImageSize<extra_images>, string>>,
                        props.size,
                        getClassName(options, 'image_classname', 'w-100'),
                        props.image_alt,
                        props.get_default_data_src,
                        props.get_default_data_srcset
                      ).run(_ => {})}
                    </div>
                  ) : (
                    <div className={getClassName(options, 'placeholder_classname', '')} aria-hidden="true" />
                  )
                ) : (
                  props.kind_media === 'video' &&
                  props.video !== undefined && (
                    <div className={getClassName(options, 'video_wrap_classname', '')}>
                      {video('image' in props && cmsState.images.has(props.image) && imageState.kind == 'loaded' ? imageState.value.get(props.size || 'full') : '')(props.video).run(() => null)}
                    </div>
                  )
                )}

                {props.caption && (
                  <figcaption className={getClassName(options, 'figcaption_classname', '')}>
                    <p className={getClassName(options, 'caption_classname', 'small text-secondary text-center mt-2')}>
                      {props.caption}
                    </p>
                  </figcaption>
                )}
              </figure>
            </div>
          </section>
        )
      }
    })
}
